import React from 'react'
import { Container, Flex, Box, css, Text } from 'theme-ui'
import ContentText from '@solid-ui-components/ContentText'
import Reveal from '@solid-ui-components/Reveal'
import Divider from '@solid-ui-components/Divider'
import ContentImages from '@solid-ui-components/ContentImages'
import QuickSignupForm from '@solid-ui-components/Educabot/QuickSignupForm'
import ContentButtons from '@solid-ui-components/ContentButtons/ContentButtons'
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent'
import { Newsletter } from '../../../../../solid-ui-components/src/Newsletter/Newsletter'

const styles = {
  container: {
    margin: 'auto', 
    width: '90%',
    '@media (max-width: 420px)': {
      width: '95%'
    }
  },
  contentTitle: {
    '@media (max-width: 991px)': {
      mt: 5
    }
  },
  title: {
    fontSize: '35px',
    color: '#FFFFFF',
    lineHeight: '3rem',
    '@media (max-width: 560px)': {
      fontSize: 35,
      textAlign: 'left'
    },
    '@media (max-width: 420px)': {
      fontSize: 30
    },
  },
  subtitle: {
    '@media (max-width: 560px)': {
      textAlign: 'left'
    },
  },
  icon: {
    '@media (max-width: 991px)': {
      margin: 'auto',
      textAlign: 'left'
    },
    '@media (max-width: 791px)': {
      margin: 'auto',
      width: 400,
      textAlign: 'left'
    },
  }
}

const HeroBlock01 = ({
  content: { text = [], images, buttons, form, icon },
  reverse
}) => (
  <Box sx={styles.container}>
    <Flex
      sx={{
        alignItems: [null, null, null, `center`],
        flexDirection: [
          reverse ? `column` : `column-reverse`,
          null,
          null,
          reverse ? `row-reverse` : `row`
        ]
      }}
    >
      <Box
        sx={{
          flexBasis: [null, null, null, `3/5`],
          [reverse ? 'ml' : 'mr']: [null, null, null, 5],
          position: `relative`,
          textAlign: `center`,
        }}
      >
        <ContentImages
          content={{ images }}
          loading='eager'
          reverse={reverse}
          imagePosition='center'
        />
      </Box>

      <Box
        sx={{
          flexBasis: `2/5`,
          textAlign: [`center`, null, null, `left`]
        }}
      >
        <Reveal effect='fadeInDown'>
            <Box sx={styles.contentTitle}>
              <Text sx={styles.title} mb='4'>
                Suscribite a nuestro <span style={{ color: '#2A205E', fontWeight: 600,}}>newsletter</span>
              </Text>
            </Box>
          <ContentText sx={styles.subtitle} content={text} />
        </Reveal>
        {buttons && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [4, null, null, 0] })}
          >
            {buttons && (
              <>
                <Divider space={4} />
                <ContentButtons content={buttons} />
              </>
            )}
          </Reveal>
        )}
        {form && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [2, null, null, 0] })}
          >
            {/* <QuickSignupForm {...form} space={3} /> */}
            <Newsletter />
            {/* <div style={{background : '#FFF', width: '100%', borderRadius: '5px'}}>
              <iframe width="540" height="305" src="https://58079a7a.sibforms.com/serve/MUIEAN2kckSBqi087IoQO8Yylu-aIluJ10QkETLP1MYCrs2jaquno8BLB3FPfcNeLpD6tgZOOsIh9kXwy0P7boyhTgo_qRtQTpv9lHTUZmSFZwtRZ1r5R9AvjaO32JGHuhNC8aEErMOhIeo85MCi96TWn4Yr-CmGca03dCvX3FmH9UrzLWH44Qzn7mL6_mJ7MsdIfjC3r7G-oVai" frameborder="0" scrolling="auto" allowfullscreen style={{display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '100%'}}></iframe>
            </div> */}
          </Reveal>
        )}
      </Box>
    </Flex>
  </Box>  
)


export default WithDefaultContent(HeroBlock01)
